import React, { useState } from "react";
import './FAQ 2.css';
import group from "../assets/Group 1618873795.png"
const mockData = [
    {
        id: 1,
        question: "What documents are required for visa application?",
        answer: "Required documents typically include: valid passport, completed application form, passport-size photos, proof of financial means, travel itinerary, and accommodation details."
    },
    {
        id: 2,
        question: "How long does visa processing take?",
        answer: "Standard processing time is 5-7 working days. Express service options are available for urgent cases with additional fees."
    },
    {
        id: 3,
        question: "Can I track my visa application status?",
        answer: "Yes, you can track your application status online using your reference number through our portal or VFS Global website."
    },
    {
        id: 4,
        question: "What happens if my visa is rejected?",
        answer: "In case of rejection, you'll receive a detailed explanation. You can appeal the decision or submit a new application addressing the reasons for rejection."
    }
];

const FAQ = () => {
    const [expandedId, setExpandedId] = useState(null);

    const toggleFAQ = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    return (
        <div>
            <div className="sectiontitle">Frequently Asked <span>Question</span></div>
            <div>
                {mockData.map((faq) => (
                    <div key={faq.id} style={{backgroundColor:'white',padding:'5px',margin:'15px',borderRadius:'30px',justifyContent:'center',alignItems:'center'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between', backgroundColor:'white',padding:'15px',borderRadius:'30px',fontWeight:'700'}}>
                            <div>{faq.question}</div>
                            <div onClick={() => toggleFAQ(faq.id)}>
                                <img style={{height:'30px',width:'auto'}} src={group}></img>
                            </div>
                        </div>
                        {expandedId === faq.id && (
                            <div style={{padding:'15px'}}>
                                <p>{faq.answer}</p>
                            </div>
                        )}
                        
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;

